import { CUSTOMIZATION, INTERACTIVE_SHOP, MAIN } from '../../../shared/states/names';

export const HEADER_STATES = [MAIN, CUSTOMIZATION, INTERACTIVE_SHOP];
